import "./style.css";
import Modal from "react-bootstrap/Modal";

function CompanyViews(props) {
  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "10rem", height: "4px" }} id="modalhead">
          View Item Category
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
      <div className="row gy-3">
          <div className="col-md-12">
            <label htmlFor="buyer_contact">Item Category Name</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="comp_address"
              value={props.id?.item_cat_name}
            />
          </div>
          <div className="col-12 mt-4">           
            <button
              className="branchModalCancel"
              onClick={props.hide}
              style={{ float: "right" }}
              to="/branch"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CompanyViews;
